import type { Oordeel } from './normen';

/**
 * Story 31.5 — de enige plek waar een oordeel een kleur krijgt.
 *
 * Eén tabel voor alle drie de plekken op het scherm, zodat de kaart, de tabel en de grafiek
 * onmogelijk uit elkaar kunnen lopen: dezelfde meting tegen dezelfde norm hoort overal dezelfde
 * kleur te dragen.
 *
 * Groen, amber en rood staan hier — en sinds deze story nergens ánders in dit scherm (AC-8). Elke
 * kleur hier draagt betekenis; een gegevensreeks die er een van leent maakt van zichzelf een
 * oordeel.
 *
 * `geen` krijgt uitdrukkelijk GEEN kleur en ook geen gedempte variant: zonder norm of zonder meting
 * is er niets beoordeeld, en dan hoort er niets te staan.
 */
export const OORDEEL_KLEUR: Record<Oordeel, string> = {
  groen: 'text-[var(--success-dark)]',
  amber: 'text-[var(--warning-text)]',
  rood: 'text-[var(--destructive)]',
  geen: '',
};
